/**
 * Billing Entities feature auto-registration and exports
 *
 * This module automatically registers the billing entities feature when imported,
 * enabling management of billing identities (NPI + Tax ID).
 */

import { autoRegisterFeature } from '@store/features/factory';

import { billingEntitiesFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(billingEntitiesFeature);

// Export shared components
export {
  type BillingEntityAddressFormData,
  BillingEntityForm,
  type BillingEntityFormData,
  initialBillingEntityFormData,
  type PayToToggleSource,
  TAXONOMY_CODES,
} from './components/BillingEntityForm';
// Export store (all store-related exports)
export * from './store';
// Export types
export * from './types';
// Export utils
export { looksLikeMailboxAddress, MAILBOX_ADDRESS_PATTERNS } from './utils/addressHeuristics';
export { describeNpiCheck, type NpiCheckNotice } from './utils/npiCheckNotice';
export {
  PAY_TO_ADDRESS_ERROR_KEYS,
  type PayToAddressFields,
  validatePayToAddress,
} from './utils/payToAddressValidation';
